<template>
    <tr class="item-detail">
        <td colspan="3" class="versions-container">
            <div class="active-versions">
                <div class="version-container">
                    <published-version-manager
                        ref="publishedVersionManager"
                        :index="index"
                        :customer-document-id="expectedDocument.published_version != null ? expectedDocument.published_version.id : null"
                        :expected-document-name="expectedDocument.document_name"
                        @expiration-date-updated="onExpirationDateUpdated($event)"
                    ></published-version-manager>
                </div>

                <div class="version-container">
                    <draft-version-manager
                        v-if="expectedDocument.draft_version"
                        ref="draftVersionManager"
                        :index="index"
                        :customer-document-id="expectedDocument.draft_version.id"
                        :expected-document-name="expectedDocument.document_name"
                        @file-uploaded="onFileUploaded($event)"
                        @file-deleted="onFileDeleted($event)"
                        @document-validated="onDocumentValidated($event)"
                        @document-refused="onDocumentRefused($event)"
                    ></draft-version-manager>
                </div>
            </div>

            <div class="archived-versions">
                <archived-versions-manager
                    ref="archivedVersionsManager"
                    :index="index"
                    :customer-document-id="expectedDocument.current_version.id"
                    :has-archived-versions="expectedDocument.current_version.has_archived_versions"
                >
                </archived-versions-manager>
            </div>
        </td>
    </tr>
</template>

<script type="text/babel">
import PublishedVersionManager from './PublishedVersionManager'
import DraftVersionManager from './DraftVersionManager'
import ArchivedVersionsManager from './ArchivedVersionsManager'

export default {
    name:"DocumentItemDetail",
    
    props: {
        index: {
            type: Number,
            required: true
        },
        expectedDocument: {
            type: Object,
            required: true
        }
    },
    
    data () {
        return {}
    },

    components: {
        PublishedVersionManager,
        DraftVersionManager,
        ArchivedVersionsManager
    },

    methods: {
        onExpirationDateUpdated(index) {
            this.$emit('expiration-date-updated', index)
        },
        onFileUploaded(index) {
            this.$emit('file-uploaded', index)
        },
        onFileDeleted(index) {
            this.$emit('file-deleted', index)
        },
        onDocumentValidated(index) {
            this.$emit('document-validated', index)
        },
        onDocumentRefused(index) {
            this.$emit('document-refused', index)
        }
    }
}
</script>

<style lang="scss" scoped>
    td.versions-container {
        padding: 0;
        background-color: #f0f0f0;

        .active-versions {
            display: flex;
            gap: 1px;
            background-color: #bbb;
            margin: 20px 0;

            .version-container {
                width: 50%;
                padding: 20px 80px;
                background-color: #f0f0f0;
            }
        }

        .archived-versions {
            margin: 20px;
        }
    }
</style>


// WEBPACK FOOTER //
// client/components/CustomerDocuments/ItemDetail.vue